import { useQuery, UseQueryOptions } from 'react-query';
import { getAllEmployees } from 'RestAPIs/employees';

const useGetEmployeeList = (options?: UseQueryOptions<any, unknown, any>) => {
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: ['allEmployees'],
    queryFn: async () => {
      const { data } = await getAllEmployees();
      return data;
    },
    ...options
  });
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeList;
